import { APIClient } from '../api_helper';
import { api } from '../../config';

import * as url from './url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_AUTH_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Login Method
export const postLogin = data =>
	apiClient.post(url.POST_LOGIN, stringifyParams(data), {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});

export const postAzureLogin = code =>
	apiClient.post(
		`${url.POST_AZURE_LOGIN}?${stringifyParams({
			code,
		})}`
	);

// Get profile
export const getProfile = () => apiClient.get(url.GET_PROFILE);

// USER
export const getUserList = () => apiClient.get(url.GET_USERS);
export const getUser = username =>
	apiClient.get(url.USER + '/' + encodeURIComponent(username));
export const addNewUser = user => {
	return apiClient.post(url.ADD_USER, user);
};
export const updateUser = ({ username, user }) =>
	apiClient.put(
		url.UPDATE_USER + '/' + encodeURIComponent(username) + '/',
		user
	);
export const deleteUser = username =>
	apiClient.delete(url.DELETE_USER + '/' + encodeURIComponent(username));
export const privacyPolicyUser = () => apiClient.post(url.PRIVACY_POLICY_USER);
export const passwordUser = ({ username, password }) =>
	apiClient.put(`${url.PASSWORD_USER}/${encodeURIComponent(username)}`, {
		password,
	});
export const infoUser = ({ username, user }) =>
	apiClient.put(`${url.INFO_USER}/${encodeURIComponent(username)}`, { user });
export const establishmentUser = ({ username, user }) =>
	apiClient.put(`${url.ESTABLISHMENT_USER}/${encodeURIComponent(username)}`, {
		user,
	});

export const postJwtForgetPwd = (email, systemUrl) =>
	apiClient.post(
		`${url.POST_JWT_PASSWORD_FORGET}?${stringifyParams({
			email: email,
			url: systemUrl,
		})}`
	);

export const postJwtResetPwd = data =>
	apiClient.post(
		url.POST_JWT_PASSWORD_RESET,
		{ token: data.token, new_password: data.confirmPassword },
		{ headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
	);

// ROLES
export const getRolesList = () => apiClient.get(url.GET_ROLES);
export const getRole = id => apiClient.get(url.GET_ROLE + id);
export const addRole = role => apiClient.post(url.ADD_ROLE, role);
export const updateRole = ({ id, role }) =>
	apiClient.put(url.UPDATE_ROLE + id, role);
export const deleteRole = id => apiClient.delete(url.DELETE_ROLE + id);

// Menu Scopes
export const getMenuScopesRole = id =>
	apiClient.get(url.GET_MENU_SCOPES_ROLE + id);

// SCOPES
export const getScopesList = () => apiClient.get(url.GET_SCOPES);
export const getScope = id => apiClient.get(url.GET_SCOPE + id);
export const addScope = scope => apiClient.post(url.ADD_SCOPE, scope);
export const updateScope = ({ id, scope }) =>
	apiClient.put(url.UPDATE_SCOPE + id, scope);
export const deleteScope = id => apiClient.delete(url.DELETE_SCOPE + id);

// Residue Conversion
export const getEstablishmentAssignationList = params => {
	return apiClient.get(
		`${url.GET_ESTABLISHMENT_ASIGNATIONS}?${stringifyParams(params)}`
	);
};
export const getEstablishmentAssignation = establishmentAssignation =>
	apiClient.get(
		url.ESTABLISHMENT_ASIGNATION +
			'/' +
			encodeURIComponent(establishmentAssignation)
	);
export const addNewEstablishmentAssignation = establishmentAssignation =>
	apiClient.post(url.ADD_ESTABLISHMENT_ASIGNATION, establishmentAssignation);
export const updateEstablishmentAssignation = establishmentAssignation =>
	apiClient.put(
		url.UPDATE_ESTABLISHMENT_ASIGNATION + '/' + establishmentAssignation._id,
		establishmentAssignation
	);
export const deleteEstablishmentAssignation = establishmentAssignation =>
	apiClient.delete(
		url.DELETE_ESTABLISHMENT_ASIGNATION + '/' + establishmentAssignation._id
	);

// User por Role
export const getUserByRoles = params => {
	return apiClient.get(`${url.GET_USER_BY_ROLES}?${stringifyParams(params)}`);
};
